// src/components/WhatsAppChat.js

import React, { useState } from 'react';
import { FaWhatsapp, FaTimes, FaPaperPlane } from 'react-icons/fa';

const ChatBot = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const phoneNumber = '919871115060'; // Replace with your full WhatsApp number (with country code)

  const handleSend = () => {
    if (!message.trim()) return;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    setMessage('');
    setOpen(false);
  };

  return (
    <div>
      {/* Floating Button */}
      <div
      
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
          opacity: open ? 0 : 1,
          transform: open ? 'scale(0.8)' : 'scale(1)',
          pointerEvents: open ? 'none' : 'auto',
          zIndex: 1000,
        }}
      >
        <button
          onClick={() => setOpen(true)}
          style={{
            backgroundColor: '#14A44D',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: '55px',
            height: '55px',
            boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
            cursor: 'pointer',
          }}
        >
          <FaWhatsapp size={28} />
        </button>
      </div>

      {/* Chat Box */}
      <div
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '300px',
          backgroundColor: '#fff',
          borderRadius: '15px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          transform: open ? 'scale(1)' : 'scale(0.8)',
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',
          transition: 'transform 0.2s ease-in-out, opacity 0.3s ease-in-out',
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: '#14A44D',
            padding: '10px 15px',
            color: '#fff',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          Chat with us
          <FaTimes
            style={{ cursor: 'pointer' }}
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Input area */}
        <div style={{ padding: '10px', display: 'flex', alignItems: 'center' }}>
          <input
            type="text"
            placeholder="Type your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{
              flex: 1,
              border: '1px solid #ddd',
              borderRadius: '5px',
              padding: '8px',
              marginRight: '8px',
              fontSize: '0.9rem',
            }}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
          />
          <button
            onClick={handleSend}
            style={{
              backgroundColor: '#14A44D',
              border: 'none',
              padding: '8px 10px',
              borderRadius: '5px',
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            <FaPaperPlane />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatBot;
